import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { DatatableService } from 'src/app/services/datatable.service';
import { ModuleService } from 'src/app/services/modules/module.service';

@Component({
  selector: 'app-cm-permissions-list',
  templateUrl: './cm-permissions-list.component.html',
  styleUrls: ['./cm-permissions-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmPermissionsListComponent extends DestructorComponent implements AfterViewInit {

  data:any;

  constructor(private datatableService: DatatableService, private _primaryService:ModuleService) { 
    super()
  }

  ngAfterViewInit(): void {
    this.datatableService.init('kt_table_permissions');
  }
  
  ngOnInit(){
    this.getData();
  }

  getData(){

    this.subscriptions.push(this._primaryService.GetData("1").subscribe((res:any)=>{
      this.data = res.data.data;
    }))

  }



}
